import * as PIXI from "pixi.js";
import PIXISpine from "Plugins/pixi-spine";
import OliverParticle from "Game/PixiCores/Particles/Oliver/OliverParticle";
import trail from "Game/Assets/trail.png";
import utils from "Service/UtilsCalculate";
import { Tween, Tweener } from "Classes/Tween";
import * as Sentry from "@sentry/react";

const character = {
  scale: 0.1,
  sequence: {
    idle: [{ name: "Idle", loop: true }],
    move: [{ name: "Move", loop: true }],
    charge: [
      { name: "Charging", loop: false },
      { name: "ChargingLoop", loop: true, delay: 0 },
    ],
    attack: [
      { name: "Attack", loop: false },
      { name: "Idle", loop: true, delay: 0 },
    ],
    attackOnce: [
      { name: "Idle", loop: true },
      { name: "Charging", loop: false, delay: 0.5 },
      { name: "Attack", loop: false, delay: 0 },
      { name: "Idle", loop: true, delay: 0 },
    ],
    hit: [
      { name: "Idle", loop: true },
      { name: "Hit", loop: false, delay: 0.2 },
      { name: "Idle", loop: true, delay: 0 },
    ],
    win: [{ name: "Win", loop: true }],
    lose: [{ name: "Lose", loop: false }],
  },
  event: {
    GunFired: () => {
      // character.controller.setFiredBulletTo(
      //   character.controller.targetPosition
      // );
    },
    Charge: () => {},
    ChargeLoop: () => {},
  },
  eventListener: {
    event: (entry, { data }) => {
      const { name } = data;
      character.event[name]?.();
    },
  },
  playSequence: (spine, sequenceData) => {
    if (!sequenceData || sequenceData.length === 0) return;
    spine.state.setAnimation(0, sequenceData[0].name, sequenceData[0].loop);
    for (let i = 1; i < sequenceData.length; i++)
      spine.state.addAnimation(
        0,
        sequenceData[i].name,
        sequenceData[i].loop,
        sequenceData[i].delay
      );
  },
  initial: async (app, path) => {
    return new Promise((resolve, reject) => {
      const preload = new PIXI.Loader();
      preload.add("character_VND_002", path);
      preload.load(async (loader, resources) => {
        // console.log("resources", resources);
        if (app.loader.resources) {
          app.loader.resources.character_VND_002 = resources;
        }
        // console.log("app", app);
      });
      preload.onComplete.add(async () => {
        await OliverParticle.initial();
        resolve("load Oliver complete");
      });
      preload.onError.add((e) => {
        reject(e);
      });
    });
  },
  create: async (app, audioRef, path, preload) => {
    return new Promise((resolve, reject) => {
      // console.log("path", path);
      let promises = [
        new Promise((resolve, reject) => {
          // const preload = new PIXI.Loader();
          // let preload = loader;
          // console.log("preload", preload);
          if (!preload.resources.character_VND_002) {
            preload.add("character_VND_002", path);
          }

          preload.load(async (loader, resources) => {
            let spineData =
              resources["character_VND_002"].character_VND_002.spineData;
            // console.log("spineData from oliver", spineData);
            if (spineData) {
              let spine = new PIXISpine.Spine(spineData);
              spine.scale.set(character.scale);
              spine.state.addListener(character.eventListener);

              let container = new PIXI.Container();
              let containerParticle = new PIXI.Container();
              let containerBullet = new PIXI.Container();
              let containerTrail = new PIXI.Container();
              let emitterController;

              // container.addChild(spine);
              container.addChild(spine);
              container.addChild(containerParticle);
              container.addChild(containerBullet);
              container.addChild(containerTrail);

              await OliverParticle.load(
                app,
                containerParticle,
                containerBullet
              ).then((particle) => {
                emitterController = particle;
              });

              const controller = {
                spine,
                container,
                containerParticle,
                containerBullet,
                emitterController,
                targetPosition: {
                  x: 0,
                  y: 0,
                },
                moveSpeed: 100,
                isMoving: false,
                infoCharacter: {
                  characterName: "oliver",
                },
                setActive: (isActive) => {
                  container.visible = isActive;
                },
                setTargetPosition: (x, y) => {
                  character.controller.targetPosition = {
                    x: x,
                    y: y,
                  };
                },
                setParticleActive: (isActive) => {
                  emitterController.animatedSprite.gunfired.gotoAndPlay(4);
                  // console.log(spine);

                  new Tweener(app.ticker)
                    .insert(
                      0.0,
                      new Tween(0.5, (pos, dt) => {
                        if (pos === 1) {
                          containerParticle.visible = false;
                        } else {
                          containerParticle.visible = true;
                        }
                      })
                    )
                    .play();
                },
                charging: () => {},
                setFiredBulletTo: async (targetPosition) => {
                  // console.log("targetPosition", targetPosition);
                  // console.log("emitterController", emitterController);
                  containerParticle.visible = true;

                  const trailTexture = PIXI.Texture.from(trail);
                  const historyX = [];
                  const historyY = [];
                  const historySize = 20;
                  const ropeSize = 20;
                  const points = [];
                  const StartOfBullet = 90;

                  containerTrail.position.set(0, 0);
                  for (let i = 0; i < historySize; i++) {
                    historyX.push(containerBullet.position.x);
                    historyY.push(containerBullet.position.y);
                  }

                  for (let i = 0; i < ropeSize; i++) {
                    points.push(new PIXI.Point(0, 0));
                  }

                  const rope = new PIXI.SimpleRope(trailTexture, points, 0);

                  rope.blendmode = PIXI.BLEND_MODES.ADD;
                  containerTrail.position.set(
                    containerBullet.position.x + StartOfBullet,
                    -80
                  );
                  containerTrail.addChild(rope);

                  new Tweener(app.ticker)
                    .insert(
                      0.25,
                      new Tween(0.25, (pos, dt) => {
                        if (pos === 0) {
                          emitterController.animatedSprite.gunfired.gotoAndPlay(
                            4
                          );
                          audioRef.current._group["VND-002"]._list[0].play(
                            "attack"
                          );
                        }
                        if (pos === 1) {
                          containerParticle.visible = false;
                          containerBullet.visible = false;
                          containerBullet.position.set(0, 0);
                          containerTrail.position.set(0, 0);
                          containerTrail.removeChildren();
                        } else {
                          containerBullet.position.x =
                            pos * (targetPosition.x - StartOfBullet);
                          containerBullet.position.y = pos * 1;
                          if (!containerBullet.visible)
                            containerBullet.visible = true;
                          historyX.pop();
                          historyX.unshift(containerBullet.position.x);
                          historyY.pop();
                          historyY.unshift(containerBullet.position.y);
                          for (let i = 0; i < ropeSize; i++) {
                            const p = points[i];
                            const ix = utils.cubicInterpolation(
                              historyX,
                              (i / ropeSize) * historySize
                            );
                            const iy = utils.cubicInterpolation(
                              historyY,
                              (i / ropeSize) * historySize
                            );
                            p.x = ix;
                            p.y = iy;
                          }
                        }
                      })
                    )
                    .play();
                  await character.controller.routineWait(0.5).then(() => {
                    console.log("particle hit");
                  });
                },
                hurt: () => {},
                playState: (stateName) => {
                  if (character.sequence[stateName])
                    character.playSequence(
                      controller.spine,
                      character.sequence[stateName]
                    );
                },
                destroy: () => {
                  if (controller.spine) {
                    controller.spine.destroy();
                    controller.container?.destroy();
                    controller.containerParticle?.destroy();
                    controller.containerBullet?.destroy();
                    controller.containerTrail?.destroy();
                  }
                },
                routineWait: async (second) => {
                  await new Promise((resolve) => {
                    const ticker = app.ticker;
                    let current = 0;
                    const onUpdate = (elapsedTime) => {
                      const deltaTime = (1 / ticker.FPS) * ticker.speed;
                      current += deltaTime;
                      if (current > second) {
                        ticker.remove(onUpdate);
                        resolve();
                      }
                    };
                    ticker.add(onUpdate);
                  });
                },
              };
              character.controller = controller;
              resolve(controller);
            } else {
              reject({ error: "OLIVER_NO_SPINE_DATA" });
            }
          });
        }),
      ];
      Promise.all(promises)
        .then((results) => {
          const [character] = results;
          resolve(character);
        })
        .catch((e) => {
          Sentry.captureException(e);
          reject(e);
        });
    });
  },
};

export default character;
